import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import { brl } from "./PurchaseDialog";

export default function WithdrawalStatus({ balance }) {
  const [cfg, setCfg] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/config").then((r) => setCfg(r.data)).catch((err) => console.warn("Failed to load withdrawal config:", err));
  }, []);
  const min = cfg?.withdrawal_min ?? 50;
  const feePct = cfg?.withdrawal_fee_percent ?? 2;

  return (
    <div className="mb-4 p-4 rounded-xl border border-border" data-testid="withdrawal-status">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Saque via Pix</div>
          <div className="text-xs text-muted-foreground mt-1 max-w-md">
            Disponível: <b className="gold-text">{brl(balance)}</b> · mínimo {brl(min)} · taxa de {feePct.toLocaleString("pt-BR")}%.
            Pix somente para o CPF do titular.
          </div>
        </div>
        <Button className="gold-btn hover:opacity-95" onClick={() => navigate("/saque")} data-testid="withdraw-btn">
          Solicitar Saque <ArrowRight className="h-3 w-3 ml-2" />
        </Button>
      </div>
    </div>
  );
}
